import React, { Component } from 'react';
import _ from 'lodash';

import OpenQuestion from './OpenQuestion';
import MultipleChoice from './MultipleChoice';
import SingleChoice from './SingleChoice';
import MixedQuestion from './MixedQuestion';

class FieldCollection extends Component {
	constructor(props) {
		super(props);
		this.state = {
			errors: [],
			submitting: false
		};
		this.handleSubmit = this.handleSubmit.bind(this);
		this.parentStateCallback = this.parentStateCallback.bind(this);
		this.parentStateCallbackReplicaAdd = this.parentStateCallbackReplicaAdd.bind(
			this
		);
		this.parentStateCallbackReplicaRemove = this.parentStateCallbackReplicaRemove.bind(
			this
		);
		this.identifier = this.identifier.bind(this);
	}
	componentDidMount(props) {
		const initialState = {};
		_.map(this.props.fieldcollection, item => {
			initialState[item.id] = {
				validation: false
			};
		});
		this.setState(initialState);
	}
	renderFields() {
		return _.map(this.props.fieldcollection, this.identifier);
	}
	handleSubmit() {
		const prevState = _.omit(this.state, ['errors', 'submitting']);
		const errors = _.map(prevState, (value, key) => {
			if (!value.validation) {
				return key;
			}
		});
		//remove 'undefined' values
		const newState = _.compact(errors);
		this.setState(prevState => {
			return {
				errors: [...prevState.errors, ...newState]
			}
		});
		if (_.isEmpty(newState)) {
			this.setState({
				submitting: true
			});
			this.props.handleSubmitSurvey(_.omit(this.state, ['errors', 'submitting']));
		}
	}
	setErrs(id, validation) {
		if (!validation) {
			this.setState(prevState => {
				return {
					errors: [...prevState.errors, id]
				}
			});
		} else if (validation && _.includes(this.state.errors, id)) {
			this.setState(prevState => {
				return {
					errors: _.without(prevState.errors, id)
				}
			});
		}
	}
	parentStateCallback({ id, inputName, value, validation }) {
		this.setErrs(id, validation);
		this.setState(prevState => {
			return {
				[id]: {
					...prevState[id],
					inputName,
					value,
					validation
				}				
			}
		});
	}
	parentStateCallbackReplicaAdd(id, ref, replicaValue, validation) {
		this.setErrs(id, validation);
		this.setState(prevState => {
			return {
				[id]: {
					...prevState[id],
					validation,
					replica: {
						...prevState[id].replica,
						[ref]: replicaValue
					}
				}				
			}
		});
	}
	parentStateCallbackReplicaRemove(id, value) {
		const nextState = _.omit(this.state[id].replica, value);
		this.setState(prevState => {
			return {
				[id]: {
					...prevState[id],
					replica: {
						...nextState
					}
				}				
			}
		});
	}
	identifier(fieldcollection, i) {
		const { type } = fieldcollection;
		if (type === 'open-question') {
			return (
				<OpenQuestion
					key={i}
					fieldcollection={fieldcollection}
					parentStateCallback={this.parentStateCallback}
					errors={this.state.errors}
				/>
			);
		} else if (type === 'multiple-choice') {
			return (
				<MultipleChoice
					key={i}
					fieldcollection={fieldcollection}
					parentStateCallback={this.parentStateCallback}
					errors={this.state.errors}
				/>
			);
		} else if (type === 'single-choice') {
			return (
				<SingleChoice
					key={i}
					fieldcollection={fieldcollection}
					parentStateCallback={this.parentStateCallback}
					errors={this.state.errors}
				/>
			);
		} else if (type === 'mixed-question') {
			return (
				<MixedQuestion
					key={i}
					fieldcollection={fieldcollection}
					parentStateCallback={this.parentStateCallback}
					parentStateCallbackReplicaAdd={this.parentStateCallbackReplicaAdd}
					parentStateCallbackReplicaRemove={
						this.parentStateCallbackReplicaRemove
					}
					errors={this.state.errors}
				/>
			);
		}
		return null;
	}
	renderBtn() {
		if (this.state.submitting) {
			return <div className="alert alert-primary">Enviando el formulario.</div>;
		}
		return (
			<button
				className={
					_.isEmpty(this.state.errors)
						? 'btn btn-success'
						: 'btn btn-secondary disabled'
				}
				onClick={this.handleSubmit}
			>
				Enviar Encuesta
			</button>
		);
	}
	render() {
		return (
			<React.Fragment>
				{this.renderFields()}
				{this.renderBtn()}
				<br />
				<br />
				<br />
			</React.Fragment>
		);
	}
}

export default FieldCollection;



// WEBPACK FOOTER //
// ./src/components/Survey/consumer/FieldCollection/index.js